import { Eye, EyeOff } from 'lucide-react'
import {
	type ComponentPropsWithoutRef,
	type ComponentRef,
	forwardRef,
	useState,
} from 'react'
import { Input } from '~/components/ui/input'
import { cn } from '~/lib/utils'

export const PasswordCreationInput = forwardRef<
	ComponentRef<typeof Input>,
	ComponentPropsWithoutRef<typeof Input>
>((props, ref) => {
	const [showMdp, setShowMdp] = useState(false)

	const passType = showMdp ? 'text' : 'password'
	const Icon = showMdp ? EyeOff : Eye

	return (
		<div className='relative'>
			<Input
				{...props}
				ref={ref}
				type={passType}
				className={cn('pr-12', props.className)}
			/>

			<button
				className='absolute inset-0 left-auto flex h-full w-12 items-center justify-center'
				type='button'
				onClick={() => setShowMdp((showMdp) => !showMdp)}
			>
				<Icon size={18} />
			</button>
		</div>
	)
})

PasswordCreationInput.displayName = 'PasswordCreationInput'
